
import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = 768; // Mudando para md breakpoint (768px) para incluir tablets

export function useIsMobile() {
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(() => {
    // Verificação inicial na montagem do componente
    if (typeof window !== 'undefined') {
      return window.innerWidth < MOBILE_BREAKPOINT;
    }
    return false;
  });
  
  // Detecção adicional de sistema operacional
  const [isIOSDevice, setIsIOSDevice] = useState<boolean>(() => {
    if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
      return /iPhone|iPad|iPod|iOS/.test(navigator.userAgent);
    }
    return false;
  });

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    
    const onChange = () => {
      setIsSmallScreen(window.innerWidth < MOBILE_BREAKPOINT);
    };
    
    // Usa addEventListener para melhor suporte
    if (mql.addEventListener) {
      mql.addEventListener("change", onChange);
    } else {
      // Fallback para browsers antigos
      mql.addListener(onChange);
    }
    
    // Garante que o estado inicial está correto
    setIsSmallScreen(window.innerWidth < MOBILE_BREAKPOINT);
    
    return () => {
      if (mql.removeEventListener) {
        mql.removeEventListener("change", onChange);
      } else {
        // Fallback para browsers antigos
        mql.removeListener(onChange);
      }
    };
  }, []);

  // Retorna true se for um dispositivo móvel baseado no tamanho da tela ou se for um dispositivo iOS
  return isSmallScreen || isIOSDevice;
}
